module.exports = __webpack_public_path__ + "img/energy_3.54b2efb7.png";